import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { useEmployments } from '@builddocs/data-management'
import {
  Typography,
  Popover,
  PopoverProps,
  ListSubheader,
  Pagination,
  Stack,
} from '@mui/material'

import { EmploymentPaginationSkeleton } from './molecules/employment/skeletons/EmploymentPaginationSkeleton'
import { EmploymentList } from './organisms/employment/EmploymentList'

interface OwnProps {
  popoverProps: PopoverProps
  setUnreadCount: Dispatch<SetStateAction<number>>
}

type ActionsPopoverProps = OwnProps

export const EmploymentPopover = (props: ActionsPopoverProps) => {
  const { popoverProps, setUnreadCount } = props
  const [page, setPage] = useState<number>(1)

  const {
    isLoading,
    isError,
    refetch,
    employments,
    refreshUnreadCount,
    pageCount,
  } = useEmployments(popoverProps.open, page - 1)

  useEffect(() => {
    if (popoverProps.open) {
      refreshUnreadCount()
      refetch()
    }
  }, [popoverProps.open])

  useEffect(() => refetch(), [page])

  useEffect(() => {
    if (isError && page > 1) setPage(1)
  }, [isError])

  return (
    <Popover
      {...popoverProps}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: { sm: 600, xs: 'calc(100% - 32px)' },
          pb: employments.length === 0 && !isLoading ? 2 : 0,
        },
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <ListSubheader sx={{ maxWidth: 600, sm: { width: '100%' } }}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Typography
            color="text.primary"
            component="span"
            fontSize={16}
            fontWeight={500}
            sx={{ pt: 2, mb: 2 }}
            textTransform="uppercase"
            variant="body1"
          >
            Уведомления
          </Typography>
        </Stack>
      </ListSubheader>
      <EmploymentList
        employments={employments}
        isLoading={isLoading}
        refetch={refetch}
        setUnreadCount={setUnreadCount}
      />
      {!isLoading ? (
        pageCount > 1 && (
          <Pagination
            aria-label="Навигация по уведомлениям"
            count={pageCount}
            page={page}
            sx={{
              my: 2,
              ml: 1,
              justifyContent: 'left',
              display: 'flex',
              position: 'sticky',
              bottom: 0,
              bgcolor: 'background.paper',
            }}
            onChange={(_e, page) => setPage(page)}
          />
        )
      ) : (
        <EmploymentPaginationSkeleton />
      )}
    </Popover>
  )
}
